<template>
  <div class="payorder">
    <center-header active="order"></center-header>
    <!-- 选择栏 -->
    <div class="main-flex main-flex-center seach u-centent">
      <div class="main-flex main-flex-center">
        <img src="../assets/img/logo.png">
        <div class="main-font24 margin-l-20">{{$t('member.cgdd')}}</div>
      </div>
      <div class="">
        <a-select :default-value="statusData[0].name" style="width: 500px" @change="handleChange">
          <a-select-option v-for="(item,index) in statusData" :key="index" :value="index">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="u-centent">
      <div class="main-font20 u-title font-bold margin-b-20">{{status}}</div>
      <div class="line"></div>
      <!-- 表格 -->
      <div class="p-table">
        <div class="title">
          <a-row type="flex" justify="center" align="middle">
            <a-col flex="100px">
              <div class="text-left">
                <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"> {{$t('member.all')}} </a-checkbox>
              </div>
            </a-col>
            <a-col :flex="1" v-for="(item,i) in columns" :key="i">{{item}}</a-col>
          </a-row>
        </div>
        <div class="u_table_info">
          <a-checkbox-group v-model="checkedList" @change="onChange">
            <div v-for="(item,i) in data" :key="i">
              <!-- 除了待付款 -->
              <div v-if="type==item.ship_status && item.paid_at">
                <div class="info_title">
                  <a-row type="flex" justify="space-between" align="middle">
                    <a-col>
                      <a-checkbox :value="item.no"> {{$t('member.orderNum')}}：{{item.no}} </a-checkbox>
                      <a href="javascript:;" style="color: #EA5D59;margin-left: 30px;" class="main-font16" @click="onDelete(item.no)">{{$t('member.del')}}</a>
                      <a href="javascript:;" style="color: #1F5EA5;margin-left: 30px;" class="main-font16" @click="onReceipt(item.no)" v-if="status=='运输中'">{{$t('member.qrsh')}}</a>
                    </a-col>
                    <a-col>
                      <div class="u-right" v-if="status=='待付款'">
                        {{$t('title.xj')}}:<span class="span">￥{{item.total_amount}}</span>
                        <div class="u-btn" style="">
                          <a-button type="primary" block @click="GoPay(item.no,item.total_amount)"> {{$t('member.js')}} </a-button>
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <div class="info_item">
                  <div class="item" v-for="(info,index) in item.items" :key="index">
                    <a-row type="flex" justify="center" align="middle">
                      <a-col :flex="1">{{info.category}} {{info.series}}-{{info.name}}</a-col>
                      <a-col :flex="1">{{info.specifications.models}}</a-col>
                      <a-col :flex="1">{{info.amount}}</a-col>
                      <a-col :flex="1">￥{{info.price}}</a-col>
                      <a-col :flex="1">
                        <div class="text-decoration" style="color: #999;padding-bottom: 5px;" v-if="info.amount>=info.specifications.discount_quantity">￥{{info.price * info.amount | numFilter}}</div>
                        <div v-if="info.amount>=info.specifications.discount_quantity">￥{{info.price * info.amount * (info.specifications.discount/10) | numFilter}}</div>
                        <div v-else>￥{{info.price * info.amount | numFilter}}</div>
                      </a-col>
                      <a-col :flex="1">{{item.paid_at}}</a-col>
                      <a-col :flex="1" style="color: #1F5EA5;">{{status}}</a-col>
                      <a-col :flex="1" v-if="status=='已完成'">
                        <div class="hr">
                          <span> <a-button type="link" @click="showHt(item.no)">{{$t('member.yl')}}</a-button> </span>
                          <span> <a-button type="primary" block @click="getHt(item.no)">{{$t('title.download')}}</a-button> </span>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
              <!-- 待付款 -->
              <div v-if="type=='paid' && !item.paid_at">
                <div class="info_title">
                  <a-row type="flex" justify="space-between" align="middle">
                    <a-col>
                      <a-checkbox :value="item.no"> {{$t('member.orderNum')}}：{{item.no}} </a-checkbox>
                      <a href="javascript:;" style="color: #EA5D59;margin-left: 30px;" class="main-font16" @click="onDelete(item.no)">{{$t('member.del')}}</a>
                    </a-col>
                    <a-col>
                      <div class="u-right" v-if="status=='待付款'">
                        {{$t('title.xj')}}:<span class="span"><span class="text-decoration main-font16 margin-lr-10" style="color: #999;">￥{{item.money | numFilter}}</span> ￥{{item.total_amount}}</span>
                        <div class="u-btn" style="">
                          <a-button type="primary" block @click="GoPay(item.no,item.total_amount)"> {{$t('member.js')}} </a-button>
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <div class="info_item">
                  <div class="item" v-for="(info,index) in item.items" :key="index">
                    <a-row type="flex" justify="center" align="middle">
                      <a-col :flex="1">{{info.category}} {{info.series}}-{{info.name}}</a-col>
                      <a-col :flex="1">{{info.specifications.models}}</a-col>
                      <a-col :flex="1">{{info.amount}}</a-col>
                      <a-col :flex="1">￥{{info.price}}</a-col>
                      <a-col :flex="1">
                        <div class="text-decoration" style="color: #999;padding-bottom: 5px;" v-if="info.amount>=info.specifications.discount_quantity">￥{{info.price * info.amount | numFilter}}</div>
                        <div v-if="info.amount>=info.specifications.discount_quantity">￥{{info.price * info.amount * (info.specifications.discount/10) | numFilter}}</div>
                        <div v-else>￥{{info.price * info.amount | numFilter}}</div>
                      </a-col>
                      <a-col :flex="1">{{item.created_at}}</a-col>
                      <a-col :flex="1" style="color: #1F5EA5;">{{status}}</a-col>
                      <a-col :flex="1" v-if="status=='已完成'">
                        <div class="hr">
                          <span> <a-button type="link" @click="showHt(item.no)">{{$t('member.yl')}}</a-button> </span>
                          <span> <a-button type="primary" block @click="getHt(item.no)">{{$t('title.download')}}</a-button> </span>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
            </div>
          </a-checkbox-group>
        </div>
      </div>
    </div>
    <!-- 结算 -->
    <div class="CheckOut">
      <div class="u-centent main-font16">
        <div class="u-left main-flex main-flex-center">
          <!-- <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"> {{$t('member.all')}} </a-checkbox> -->
          <!-- <a href="javascript:;" style="color: #EA5D59;margin-left: 30px;" class="main-font16" @click="onAllDelete">{{$t('member.del')}}</a> -->
        </div>
      </div>
    </div>
    <!-- 合同预览 -->
    <a-modal v-model="showht" :closable="true" :centered="true" width="500px" on-ok="handleOk" :footer="null">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleOk">
          {{$t('title.download')}}
        </a-button>
      </template>
      <div class="htImg">
        <iframe :src="'http://'+ht.document_file" frameborder="0" width="100%" height="100%" v-if="$store.state.langStates == 'zh'"></iframe>
        <iframe :src="'http://'+ht.document_file_en" frameborder="0" width="100%" height="100%" v-else></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import axios from 'axios';
  import CenterHeader from './common/CenterHeader'
  const statusData = [{
    type:'pending',
    name:'生产中'
  },
  {
    type:'paid',
    name:'待付款'
  },
  {
    type:'delivered',
    name:'运输中'
  },
  {
    type:'received',
    name:'已完成'
  }]
  const columns = ['产品名称', '型号', '数量', '单价', '总价', '采购时间', '订单状态']
  const data = []
  export default {
    components: {
      CenterHeader
    },
    data() {
      return {
        statusData,
        columns,
        data,
        span: 3,
        status: '生产中',
        type:'pending',
        num: 1,
        shopNum: 0,
        shopTotal: 0,
        showht: false,
        indeterminate:false,
        checkAll:false,
        checkedList:[],
        ht:''
      }
    },
    filters: {
      numFilter(value) {
        let realVal = ''
        if (!isNaN(value) && value !== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = '--'
        }
        return realVal
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/download') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods: {
      // 进入页面加载
      init(lang) {
        this.data = []
        this.$api.dongjuapi.orders({limit:100}).then(res => {
          this.data = res.data.data
        })
      },
      // 点击下载
      handleOk() {
        console.log('下载')
      },
      // 切换订单状态
      handleChange(value) {
        this.checkedList = []
        this.checkAll = false
        this.indeterminate = false
        this.status = this.statusData[value].name
        this.type = this.statusData[value].type
        console.log(this.type)
        const newcolumns = ['产品名称', '型号', '数量', '单价', '总价', '采购时间', '订单状态', '电子合同']
        if (this.type == 'received') {
          this.columns = newcolumns
        } else {
          newcolumns.splice(7, 1)
          this.columns = newcolumns
        }
      },
      // 多选框单选
      onChange(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < this.data.length;
        this.checkAll = checkedList.length === this.data.length;
      },
      // 全选
      onCheckAllChange(e){
        const no = []
        for(var i=0;i<this.data.length;i++){
          if(this.type == this.data[i].ship_status && this.data[i].paid_at){
            no.push(this.data[i].no)
          }else if(this.type=='paid' && !this.data[i].paid_at){
            no.push(this.data[i].no)
          }
        }
        console.log(no)
        Object.assign(this, {
          checkedList: e.target.checked ? no : [],
          indeterminate: false,
          checkAll: e.target.checked,
        });
      },
      // 预览合同
      showHt(ids) {
        this.showht = true
        var lang = this.$store.state.langStates
        this.$api.dongjuapi.order_contract({
          no:ids,
          lang
        }).then(res=>{
          if(res.data.code==200){
            this.ht = res.data.data
          }
        })
      },
      getHt(ids){
        var lang = this.$store.state.langStates
        this.$api.dongjuapi.order_contract({
          no:ids,
          lang
        }).then(res=>{
          if(res.data.code==200){
            let url = ''
            if(lang == "zh"){
              url = 'http://' + res.data.data.document_file
            }else{
              url = 'http://' + res.data.data.document_file_en
            }
            window.open(url)
            // axios.get(url, {
            //   responseType: 'blob'
            // }).then(({
            //   data
            // }) => {
            //   let blob = new Blob([data], {
            //     type: 'application/vnd.ms-excel'
            //   })
            //   let link = document.createElement('a')
            //   link.href = window.URL.createObjectURL(blob)
            //   link.download = url.split('/').pop()
            //   link.click()
            // }).catch(err => {
            //   console.log(err)
            // })
          }
        })
      },
      // 去支付
      GoPay(no,p) {
        this.$router.push({
          path: '/settlement?no=' + no + '&price=' + p
        })
      },
      // 删除
      onDelete(no){
        this.$api.dongjuapi.delete_order({no}).then(res=>{
          if(res.data.code==200){
            this.$message.success(res.data.data)
            this.init(this.$store.state.langStates)
          }
        })
      },
      onReceipt(ids){
        this.$api.dongjuapi.received(ids).then(res=>{
          if(res.data.code==200){
            this.$message.success(res.data.data)
            this.init(this.$store.state.langStates)
          }
        })
      },
      onAllDelete(){
        console.log(this.checkedList)
        let ids = this.checkedList
        this.$api.dongjuapi.delete_order({ids}).then(res=>{
          if(res.data.code==200){
            this.$message.success(res.data.data)
            this.init(this.$store.state.langStates)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .payorder {
    width: 100%;
    height: auto;
    background: #fff;
    padding-bottom: 80px;

    .seach {
      height: 190px;
      justify-content: space-between;
      padding: 50px 0 60px 0;

      img {
        width: auto;
        height: 40px;
      }
    }

    .u-title {
      color: #1F5EA5;
      line-height: 30px;
      letter-spacing: 2px;
    }

    .line {
      width: 100%;
      height: 4px;
      background: #1F5EA5;
    }
  }

  .p-table {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 45px;
    min-height: 300px;
    max-height: 600px;
    overflow-y: auto;
    // &::-webkit-scrollbar{
    //   width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
    //   height: 1px;
    // }
    // &::-webkit-scrollbar-thumb{
    //   border-radius: 0px;
    //   box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    //   background   : #999;
    // }
    // &::-webkit-scrollbar-track{
    //   box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    //   border-radius: 0px;
    //   background   : #ededed;
    //   margin-left: 10px;
    // }
    .ant-row-flex {
      height: 100%;
    }

    .title {
      width: 100%;
      height: 50px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;

      .ant-col:nth-child(1) {
        font-weight: normal;
      }
    }

    .u_table_info {
      width: 100%;

      .ant-checkbox-group {
        width: 100%;
      }

      .info_title {
        width: 100%;
        height: 75px;
      }

      .info_item {
        width: 100%;
        height: auto;
        border: 1px solid #dbdbdb;
        border-bottom: none;

        .item {
          width: 100%;
          height: 110px;
          border-bottom: 1px solid #dbdbdb;
          text-align: center;
        }
      }
    }

    .u-right {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .u-btn {
        width: 100px;
        margin-left: 30px;

        .ant-btn {
          height: 35px;
        }
      }

      .span {
        color: #1F5EA5;
        font-weight: bold;
        font-size: 20px;
        padding: 0 5px;
      }
    }

    .hr {
      width: 172px;
      height: 35px;
      border: 1px solid #1F5EA5;
      margin: 0 auto;
      span {
        width: 85px;
        height: 34px;
        line-height: 34px;
        display: inline-block;

        .ant-btn {
          width: 100%;
          height: 34px;
          padding: 0;
          border-radius: 0;
        }
      }
    }
  }

  .htImg {
    width: 100%;
    height: 707px;

    iframe {
      width: 100%;
      height: 100%;
      padding: 14px 10px;
    }
  }

  .CheckOut {
    width: 100%;
    height: 80px;
    background: #E1E1E1;

    >div {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .u-left {
      .ant-checkbox-wrapper {
        display: flex;
        align-items: center;
      }

      .ant-checkbox+span {
        padding: 0;
        padding-left: 6px;
        font-size: 20px;
      }
    }
  }
</style>
